
app.pagesController = app.pagesController || {};
app.pagesController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    base : this,

    init : function () {
        function resizeVideo () {
            var blk = $('.header-video');
            var video = $('video', blk);

            var blkH = blk.height();
            var blkW = blk.width();

            var blkRatio = blkW / blkH;

            var videoH = video.height();
            var videoW = video.width();

            var videoRatio = videoW / videoH;

            if (videoRatio >= blkRatio) {
                video.attr('style', 'height: 100%; width: auto; top: 0; left: 50%; transform: translate(-50%, 0);');
            } else {
                video.attr('style', 'width: 100%; height: auto; top: 50%; left: 0; transform: translate(0, -50%);');
            }
        }


        if ($(".header-video").length) {
            resizeVideo();

            $( window ).resize(function() {
                resizeVideo();
            });
        }

        $('.msg').delay(5000).fadeOut('slow');
    },
};

$(document).ready(function(){
    app.pagesController.defaultAction.init();
});
